module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a href="#" class="header-wrap" data-toggle="expand-spoiler"><header><h5 class="module-title">'+
((__t=( i18n.tc( "ControlWeather", "Weather" ) ))==null?'':__t)+
' '+
((__t=( location ))==null?'':__t)+
' </h5><i class="icon icon-material icon-expand"></i></header></a><div data-region="weather-sticky"></div><div class="expand-spoiler';
 if ( isOpen ) { 
__p+=' open';
 } 
__p+='" data-container="expand-spoiler"><div class="expand-content"><div data-region="weather-container"></div></div></div><a id="weather-url" class="align-right" href="">'+
((__t=( i18n.tc("ControlWeather", "Weather forecast from yr.no, delivered by the Norwegian Meteorological Institute and the NRK") ))==null?'':__t)+
'</a>';
}
return __p;
};
